import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import { blogPosts } from '../mocks/blog';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BlogPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-5xl px-5 py-14">
          <h1 className="text-[28px] font-bold tracking-tight">{t('header.nav.blog')}</h1>
          <p className="mt-2 text-[15px] text-muted">{t('blog.section.subtitle')}</p>
          <ul className="mt-8 grid gap-5 md:grid-cols-3">
            {blogPosts.map((post) => (
              <li key={post.slug}>
                <Link
                  to={post.slug}
                  className="group block h-full rounded-xl border border-border bg-surface p-5 transition hover:border-primary cursor-pointer"
                >
                  <div className="flex items-center gap-2 text-[12px] text-muted">
                    <span className="rounded-full bg-primary-soft px-2.5 py-0.5 font-medium text-primary">
                      {t(`blog.${post.key}.category`)}
                    </span>
                    <span>{t(`blog.${post.key}.readTime`)}</span>
                  </div>
                  <div className="mt-3 text-[16px] font-semibold leading-snug text-ink group-hover:text-primary transition">
                    {t(`blog.${post.key}.title`)}
                  </div>
                  <div className="mt-2 text-[14px] leading-[1.5] text-muted">{t(`blog.${post.key}.excerpt`)}</div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
}
